enum Paths {
    urlAliasCreate = '/url-alias/create',
    urlAlias = '/url-alias',
}

export default Paths;



// WEBPACK FOOTER //
// ./src/modules/UrlAlias/paths.ts